<template>
    <div class="enterCodeWrap fc ac">
        <div class="top center">
            <img :src="isKfc ? kfcLogoIco : logoIco" alt />
        </div>
        <h3>输入短信验证码</h3>
        <p>
            验证码已发送至
            <span class="rose">(+86){{phoneNo}}</span>
        </p>
        <div class="codeWrap">
            <input
                @focus="focus = true"
                @blur="focus = false"
                v-model="code"
                type="number"
                oninput="if(value.length>6)value=value.slice(0,6)"
                maxlength="6"
            />
            <div class="labels fr ac jsb">
                <label
                    v-for="(item, index) in length"
                    :key="index"
                    v-text="codeArr[index]"
                    :class="{active: focus===true && index===currentIndex}"
                    for="code"
                ></label>
            </div>
        </div>
        <span v-show="disabled" class="reacquire grey">重新获取（{{time}}S）</span>
        <span @click="getCode" v-show="!disabled" class="reacquire rose">重新获取</span>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            focus: false,
            code: "",
            length: 6,
            disabled: false,
            time: 60,
            interval: null,
            phoneNo: this.$route.query.phoneNo,
            isKfc: this.$route.query.isKfc ? this.$route.query.isKfc : "",
            logoIco: require("../../../static/imgs/logUp/logo.png"),
            kfcLogoIco: require("../../../static/imgs/kfc/kfc.png"),
        }; 
    },
    beforeRouteEnter(to, from, next) {
        window.document.body.style.backgroundColor = "#FFF";
        next();
    },
    beforeRouteLeave(to, from, next) {
        window.document.body.style.backgroundColor = "#f2f2f2";
        next();
    },
    components: {},
    created() {
        if (this.time) {
            this.countDown();
        }
    },
    computed: {
        codeArr: function() {
            return this.code.split("");
        },
        currentIndex: function() {
            return this.code.length - 1;
        }
    },
    watch: {
        code: function(newVal, oldVal){
            if(newVal.length >= 6){
                this.login()
            }
        }
    },
    methods: {
        getCode() {
            this.$post({
                method: "auth.login.verify.send",
                mobile: this.phoneNo
            }).then(res => {
                if (res.success) {
                    this.countDown();
                    this.disabled = true;
                    // this.$router.push({path:"/enterCode", query: {phoneNo: this.phoneNo}})
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        },
        countDown() {
            this.interval = null;
            var time = this.time;
            this.disabled = true;
            this.interval = setInterval(() => {
                time--;
                this.time = time;
                if (time < 1) {
                    clearInterval(this.interval);
                    this.disabled = false;
                    this.time = 60;
                }
            }, 1000);
        },
        login() {
            this.$post({
                method: "auth.login.verify.verify",
                mobile: this.phoneNo,
                verify: this.code
            }).then(res => {
                if (res.success) {
                    this.setLocal("hasLogged", true);
                    this.setLocal("auth_code", res.data.auth_code);
                    this.setLocal("phoneNo", this.phoneNo);
                    let redirect = decodeURIComponent(
                        this.$route.query.redirect ? this.$route.query.redirect : this.isKfc ? "/kfcIndex" : "/"
                    );
                    this.$router.push({ path: redirect });
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.enterCodeWrap {
    .top {
        width: 100%;
        height: 276px;
        background-image: url(../../../static/imgs/movie/top_bg.png);
        background-size: cover;
        background-position: center;
        img {
            width: 120px;
            height: 120px;
        }
    }
    h3 {
        width: 100%;
        padding: 0 60px;
        box-sizing: border-box;
        font-size: 40px;
        margin: 50px 0 30px 0;
    }
    p {
        width: 100%;
        padding: 0 60px;
        box-sizing: border-box;
        color: #999;
        font-size: 28px;
    }
    .codeWrap {
        width: 100%;
        padding: 0 60px;
        box-sizing: border-box;
        height: 110px;
        margin-top: 40px;
        input {
            width: 100%;
            padding: 0;
            height: 110px;
            font-size: 66px;
            overflow: hidden;
            border: none;
            outline: none;
            opacity: 0;
            // margin-left: -100%; // ios上透明度为0时依然有光标
            -webkit-tap-highlight-color: transparent;
        }
        .labels {
            width: 100%;
            height: 110px;
            margin-top: -110px;
            -webkit-tap-highlight-color: transparent; // 解决ios点击灰色阴影的问题
            label {
                height: 110px;
                line-height: 110px;
                width: 12%;
                border-bottom: solid 2px #c9c9c9;
                font-size: 66px;
                text-align: center;
            }
            .active {
                border-bottom: solid 2px #ff225e;
            }
            // .active:after {
            //     // 伪类实现光标效果
            //     content: " ";
            //     display: inline-block;
            //     height: 60%;
            //     width: 1px;
            //     background: #c9c9c9;
            //     animation: 0.8s animate infinite;
            // }
        }
    }
    .reacquire {
        width: 100%;
        padding: 0 60px;
        box-sizing: border-box;
        font-size: 28px;
        height: 120px;
        line-height: 120px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/enterCode.vue